import { useMemo } from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Section } from 'foundations-components/transitional/components/Section';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Small } from 'foundations-components/transitional/components/Small';
import { callingMarketplaceAppsUrl, callingToolSettings, callingUserPreferencesUrl } from '../../utils/urlUtils';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RegisterPhoneNumberPopover({
  handleProviderSwitch,
  shouldShowProviderSelectionLink
}) {
  const portalId = useMemo(() => {
    return PortalIdParser.get();
  }, []);
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    "data-selenium-test": "register-phone-popover",
    "data-test-id": "register-phone-popover",
    paddingBlockStart: "400",
    paddingInline: "400",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "calling",
      width: 80,
      marginInlineEnd: "600"
    }), /*#__PURE__*/_jsxs(Section, {
      children: [/*#__PURE__*/_jsx(H4, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.title"
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.message"
        })
      }), /*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.bullet1"
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsxs(Small, {
            marginInlineEnd: "800",
            children: [/*#__PURE__*/_jsx(FoundationsView, {
              as: "span",
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(SuccessIcon, {
                color: "do-not-use-oz",
                size: "300"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logOutboundCalls"
            })]
          }), /*#__PURE__*/_jsxs(Small, {
            children: [/*#__PURE__*/_jsx(FoundationsView, {
              as: "span",
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(SuccessIcon, {
                color: "do-not-use-oz",
                size: "300"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logInboundCalls"
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.bullet2"
        }), /*#__PURE__*/_jsx(Section, {
          children: /*#__PURE__*/_jsxs(Small, {
            children: [/*#__PURE__*/_jsx(FoundationsView, {
              as: "span",
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(SuccessIcon, {
                color: "do-not-use-oz",
                size: "300"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logOutboundCalls"
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-selenium-test": "new-number-btn",
          use: "primary",
          href: callingToolSettings(portalId),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.buttons.newNumber"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-selenium-test": "own-number-btn",
          "data-test-id": "own-number-btn",
          use: "secondary",
          href: callingUserPreferencesUrl(portalId),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.buttons.ownNumber"
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "600",
        as: "div",
        children: /*#__PURE__*/_jsx(Small, {
          children: shouldShowProviderSelectionLink ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "callOnboardingPopover.link_jsx",
            options: {
              onClick: handleProviderSwitch,
              'data-selenium-test': 'onboarding-popover-link',
              'data-test-id': 'onboarding-popover-link'
            },
            elements: {
              UILink: Link
            }
          }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.callingIntegrations_jsx",
            elements: {
              UILink: Link
            },
            options: {
              href: callingMarketplaceAppsUrl(portalId)
            },
            "data-selenium-test": "calling-integration-link"
          })
        })
      })]
    })]
  });
}
RegisterPhoneNumberPopover.propTypes = {
  handleProviderSwitch: PropTypes.func.isRequired,
  shouldShowProviderSelectionLink: PropTypes.bool.isRequired
};
export default RegisterPhoneNumberPopover;